import { html } from '@shared/utils/rendering/html';
import { Ratings, RatingsFromId } from '../../../constants/chips/ratings.constants';
import Chip from '@shared/components/chips';
import Dropdown from '@shared/components/dropdowns';
import FileDownload from '@core/components/shared/form-fields/file-download';

export const subcomponentFormLayout = {
    uploadEvidence: { column: 'col-12', formGroup: '', css: '' },
    rating: { column: 'col-4', formGroup: '', css: '' },
    comment: { column: 'col-12', formGroup: '', css: '' },
};

const convertOptionToChip = (option) => {
    const item = RatingsFromId(option.value);

    return item
        ? html`<${Chip} label=${item.label} type="indicator-chip" css=${item.css} />`
        : option.text;
};

export const ratingFieldOverride = (inputProps, layoutSettings, options, _fieldDesc, fieldRef) => {
    const selectOptions = options?.options?.rating ?? [];

    const setValueOverride = (value, field) => {
        const newValue = Array.isArray(value) ? value : [value];
        inputProps.field.setValue(newValue, field);
    };

    const render = html`
        <div class="${layoutSettings.column}">
            <div class="form-group ${layoutSettings.formGroup}">
                <${Dropdown}
                    ref=${fieldRef}
                    ...${inputProps}
                    field=${{
                        ...inputProps.field,
                        setValue: setValueOverride,
                    }}
                    options=${selectOptions}
                    disabled=${layoutSettings.disabled}
                    settings=${{
                        type: 'input',
                        css: layoutSettings.css,
                        multiple: false,
                        transformer: convertOptionToChip,
                        selectedTransformer: convertOptionToChip,
                    }}
                />
            </div>
        </div>
    `;

    return { fieldRef, render };
};

export const subcomponentFormOptions = {
    options: {
        rating: Object.values(Ratings).map((item) => {
            return {
                value: item.value,
                text: item.text,
            };
        }),
    },
    layout: subcomponentFormLayout,
    includeSaveButton: false,
    converters: {
        rating: convertOptionToChip,
    },
    overrides: {
        rating: ratingFieldOverride,
    },
};

export const viewEvidenceFormOptions = {
    options: {
        rating: Object.values(Ratings).map((item) => {
            return {
                value: item.value,
                text: item.text,
            };
        }),
    },
    layout: subcomponentFormLayout,
    includeSaveButton: false,
    converters: {
        rating: convertOptionToChip,
    },
    overrides: {
        uploadEvidence: (inputProps, layoutSettings, options, _fieldDesc, fieldRef) => {
            const render = html`<${FileDownload}
                ref=${fieldRef}
                inputProps=${inputProps}
                layoutSettings=${layoutSettings}
            />`;
            return { render, fieldRef };
        },
        rating: ratingFieldOverride,
    },
    formProps: { disabled: true },
};
